export default "__VITE_ASSET__18f5a232__"